import React from 'react'
import { baseUrl } from '@fs/zion-config'
import { TreePedigree } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'

import BaseOfferCard from './BaseOfferCard'
import constants from '../../../../utils/constants'

/**
 * Offer card with a connect to tree CTA
 * @param {Object} props - Component props
 * @param {string} props.altTitle - Set title to: "Record Your Family"
 */
export default function FamilyTreeCard({ altTitle }) {
  const { t } = useTranslation()
  const title = altTitle
    ? t('apac.nlihp.offers.family-tree-card.alt-heading', 'Record Your Family')
    : t('apac.nlihp.offers.family-tree-card.heading', 'Family Tree')

  return (
    <BaseOfferCard
      data-testid="family-tree-card"
      title={title}
      description={t(
        'apac.nlihp.offers.family-tree-card.subheading',
        "Explore the world's largest shared online family database."
      )}
      Icon={TreePedigree}
      to={`${baseUrl}${constants.URL_LOGIN_CONNECT_TO_TREE}`}
      external
      linkName="button: family-tree: click"
    />
  )
}
